<template>
    <el-dialog v-dialogDrag class="dialog" width="600px" :visible.sync="dialogVisible" :close-on-click-modal="false"
               append-to-body
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                批量新增按钮
            </div>
        </div>

        <div class="dialog_body">
            <div style="padding: 10px;font-size: 14px;font-weight: bold">
                <span style="padding-right: 30px">选择你要新增的按钮</span>
            </div>
            <div class="Xdriver"></div>
            <div style="padding: 10px;">
                <el-checkbox-group v-model="selData" @change="selCheck">
                    <el-checkbox
                            v-for="(item,index) in btnGroup"
                            :key="index"
                            :disabled="item.disabled"
                            :label="item.buttonName"
                            style="margin: 10px"
                            border>
                    </el-checkbox>
                </el-checkbox-group>
            </div>

            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="info" @click="close">取 消</el-button>
                <el-button type="success" @click="ok">确 定</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "btnGroup",
        props: ['dataList','btnGroup'],
        data() {
            return {
                dialogVisible: true,
                selData: [],
                btnList:[{

                }],
            };
        },
        mounted() {
            this.$nextTick(() => {
                this.initData();
            })
        },
        methods: {
            initData() {
                this.selData = [];
                this.dataList.map(item => {
                    this.btnGroup.map(btn =>{
                        if(item.method === btn.method){
                            btn.disabled = true;
                            this.selData.push(btn.buttonName);
                        }
                    })
                })
            },
            selTitle() {
                this.initData();
            },
            selCheck() {
                // this.selData = [];
                // list.map(seldata => {
                //     this.btnGroup.map(item => {
                //         if (item[name] === seldata) {
                //             this.selData.push(item[name]);
                //         }
                //     })
                // })
                // console.log(this.selData);
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            ok() {
                let list = []
                this.selData.map(item=>{
                    this.btnGroup.map(btn=>{
                        if(!btn.disabled && btn.buttonName === item){
                            list.push(btn)
                        }
                    })
                })
                this.$emit('submit', list)
            },
        }
    }
</script>

<style scoped>

    .dialog .Xdriver {
        position: relative;
        margin: 0 0;
        height: 1px;
        background-color: #d4d4d4;
        text-align: center;
        font-size: 16px;
        color: rgba(101, 101, 101, 1);
    }

    .dialog /deep/ .el-dialog__header {
        padding: 0;
        text-align: center;
    }

    .dialog /deep/ .el-dialog__headerbtn {
        top: 8px;
        right: 10px
    }

    .dialog /deep/ .el-dialog__headerbtn .el-dialog__close {
        color: #FFF;
    }


    .dialog /deep/ .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 0px;
    }

    .dialog .dialog_title {
        background-color: rgba(28, 136, 201, 0.6);
        padding: 5px 10px 5px;
    }

    .dialog .dialog_body {
        border-left: 10px solid rgba(28, 136, 201, 0.6);
        border-right: 10px solid rgba(28, 136, 201, 0.6);
        border-bottom: 10px solid rgba(28, 136, 201, 0.6);
        background-color: rgba(193, 245, 236, 0.15);
    }


    .dialog /deep/ .el-checkbox.is-bordered.is-checked {
        border-color: rgba(64, 158, 255, 0.76);
    }
</style>
